module.exports = __webpack_public_path__ + "img/RFSIDS-dark.ae4c6ec0.png";